import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';

import { RecommendationsControl } from './control';
import { RecommendationsVariant1 } from './variant1';
import { RecommendationsVariant2 } from './variant2';

type Props = {
	slug: string;
};

export function selectRecommendationsVariant(variant: string) {
	switch (variant) {
		case 'variant1':
			return RecommendationsVariant1;
		case 'variant2':
			return RecommendationsVariant2;
		default:
			return RecommendationsControl;
	}
}

export function Recommendations({ slug }: Props) {
	const {
		data: {
			viewer: {
				experiments: { starterExperienceGroupRecsHorizontal },
			},
		},
	} = useStarterDashboardV2PageData();
	const Variant = selectRecommendationsVariant(starterExperienceGroupRecsHorizontal.variation);

	return <Variant slug={slug} />;
}
